import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail } from "lucide-react";
import { BrandMark, Wordmark } from "../common/Brand";

const TikTokIcon = ({ size = 18, strokeWidth = 1.25, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

export default function Footer() {
  return (
    <footer className="bg-ink text-ivory/80 pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <BrandMark size={64} invert />
            <span className="font-serif italic text-2xl text-ivory tracking-tight">
              Luxe<span className="not-italic">T</span>ini <span className="text-gold">Escapes</span>
            </span>
          </div>
          <p className="font-serif italic text-2xl text-ivory leading-snug max-w-md">
            Escape the Ordinary.<br />Travel Exceptionally.
          </p>
          <p className="mt-8 text-sm text-ivory/60 max-w-md leading-relaxed font-light">
            Bespoke travel design for discerning escape artists. Crafted by Tricia — Chief Escape Artist of LuxeTini Escapes.
          </p>
          <p className="mt-6 text-[10px] uppercase tracking-[0.28em] text-ivory/40">FL Seller of Travel · No. ST46478</p>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.28em] text-gold mb-5">Explore</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-gold transition-colors" data-testid="footer-link-home">Home</Link></li>
            <li><Link to="/about" className="hover:text-gold transition-colors" data-testid="footer-link-about">About Me</Link></li>
            <li><Link to="/services" className="hover:text-gold transition-colors" data-testid="footer-link-services">Services</Link></li>
            <li><Link to="/resources" className="hover:text-gold transition-colors" data-testid="footer-link-resources">Travel Resources</Link></li>
            <li><Link to="/blog" className="hover:text-gold transition-colors" data-testid="footer-link-blog">The Escape Edit</Link></li>
            <li><Link to="/gallery" className="hover:text-gold transition-colors" data-testid="footer-link-gallery">Captured Escapes</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.28em] text-gold mb-5">Begin</div>
          <Link
            to="/plan-your-escape"
            className="inline-flex items-center h-12 px-6 mb-6 text-[12px] uppercase tracking-[0.26em] bg-gold text-ink hover:bg-goldDeep transition-colors"
            data-testid="footer-plan-cta"
          >
            Start Your Escape
          </Link>
          <div className="mt-6 space-y-2 text-sm text-ivory/70">
            <div>
              <a href="mailto:hello@luxetiniescapes.com" className="hover:text-gold transition-colors" data-testid="footer-email-link">hello@luxetiniescapes.com</a>
            </div>
            <div className="text-ivory/50 italic">Call or Text — coming soon</div>
          </div>
          <div className="flex items-center gap-5 mt-6">
            <a href="https://www.facebook.com/profile.php?id=61588427724043" target="_blank" rel="noreferrer" className="hover:text-gold transition-colors" data-testid="footer-facebook" aria-label="Facebook">
              <Facebook size={18} strokeWidth={1.25} />
            </a>
            <a href="https://www.instagram.com/luxetiniescapes/" target="_blank" rel="noreferrer" className="hover:text-gold transition-colors" data-testid="footer-instagram" aria-label="Instagram">
              <Instagram size={18} strokeWidth={1.25} />
            </a>
            <a href="https://www.tiktok.com/@luxetiniescapes" target="_blank" rel="noreferrer" className="hover:text-gold transition-colors" data-testid="footer-tiktok" aria-label="TikTok">
              <TikTokIcon size={18} strokeWidth={1.5} />
            </a>
            <a href="https://www.youtube.com/@LuxeTiniEscapes" target="_blank" rel="noreferrer" className="hover:text-gold transition-colors" data-testid="footer-youtube" aria-label="YouTube">
              <Youtube size={18} strokeWidth={1.25} />
            </a>
            <a href="mailto:hello@luxetiniescapes.com" className="hover:text-gold transition-colors" data-testid="footer-email" aria-label="Email">
              <Mail size={18} strokeWidth={1.25} />
            </a>
          </div>
          <p className="mt-8 text-xs text-ivory/40">@luxetiniescapes &nbsp;·&nbsp; #MyLuxeEscape &nbsp;·&nbsp; #LuxeTiniEscapes</p>
        </div>
      </div>

      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-[11px] uppercase tracking-[0.24em] text-ivory/40">
        <div>© {new Date().getFullYear()} LuxeTini Escapes</div>
        <div><Link to="/admin/login" className="hover:text-gold" data-testid="footer-admin-link">Advisor Portal</Link></div>
      </div>
    </footer>
  );
}
